import {getTestProps} from '@benchling/js-test-utils';
import {CloseButton, createStyles, Divider, Stack, Text} from '@mantine/core';
import React from 'react';

import {SkillSummary} from './SkillsDAO';

interface SkillDetailPanelProps {
  skill: SkillSummary;
  onClose: () => void;
}

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing.md,
    overflowY: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing.sm,
  },
  titleBlock: {
    flex: 1,
    minWidth: 0,
  },
  description: {
    whiteSpace: 'pre-wrap',
  },
}));

export default function SkillDetailPanel({skill, onClose}: SkillDetailPanelProps): JSX.Element {
  const {classes} = useStyles();

  const formattedDate = skill.createdAt ? new Date(skill.createdAt).toLocaleDateString() : null;

  return (
    <div className={classes.container} {...getTestProps({component: 'SkillDetailPanel', element: 'root'})}>
      <div className={classes.header}>
        <div className={classes.titleBlock}>
          <Text fw={700} size="lg">
            {skill.name}
          </Text>
          {skill.creatorName && (
            <Text size="sm" c="dimmed">
              by {skill.creatorName}
            </Text>
          )}
          {formattedDate && (
            <Text size="xs" c="dimmed">
              Created {formattedDate}
            </Text>
          )}
        </div>
        <CloseButton
          onClick={onClose}
          size="sm"
          {...getTestProps({component: 'SkillDetailPanel', element: 'closeButton'})}
        />
      </div>

      <Divider my="sm" />

      <Stack spacing="xs">
        <Text size="sm" fw={600}>
          Description
        </Text>
        <Text size="sm" className={classes.description}>
          {skill.description || (
            <Text size="sm" c="dimmed" component="span">
              No description provided.
            </Text>
          )}
        </Text>
      </Stack>
    </div>
  );
}
